import styled from 'styled-components'
import theme from 'vars/theme'
import { Button } from 'reactstrap'

export const FormBlockWrapper = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${theme.grayPrimary};
  margin-bottom: ${(props) => props.hasMarginButton && '70px'};
`

export const SelectInputWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  .label {
    font-size: 14px;
    line-height: 1.2;
    word-break: break-word;
  }
`

export const RequiredText = styled.span`
  color: ${theme.redPrimary2};
  font-size: 14px;
  width: 60px;
`

export const ButtonWrapper = styled(Button)`
  &:focus {
    box-shadow: none;
  }
`
